export default __webpack_public_path__ + "f589e629ae92861c32003da0e5d4e381.svg";